export default __webpack_public_path__ + "locales/sk/DataReassignmentDialog.json?hash=69413ae33fbed4e614c8a4ed726ddd81";